export default "__VITE_PUBLIC_ASSET__0293a32b__"